<template>
  <div
    :id="`product-detail__${title}`"
    class="product-detail__block"
    :class="{ 'product-detail__block--background': hasBackgroundTitle }"
  >
    <h2
      data-test="title"
      v-if="title"
      :class="isBlockPack ? 'pack-product-detail__block-title' : 'product-detail__block-title'"
    >
      <slot name="icon"></slot>
      <slot name="title">{{ title }}</slot>
    </h2>
    <div data-test="content" class="product-detail__block-content">
      <slot name="default"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PProductDetailBlock',
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    isBlockPack: {
      type: Boolean,
      default: false,
      required: false,
    },
    hasBackgroundTitle: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style scoped lang="scss">
.product-detail__block {
  padding: var(--spacing-3) var(--spacing-4) var(--spacing-4);
  border-top: 1px solid var(--color-inactive-light);
  border-bottom: 1px solid var(--color-inactive-light);
  margin-top: var(--spacing-2);
  background: var(--color-white);
  border-radius: var(--border-radius-2);

  @media (min-width: $breakpoint-md) {
    border: 1px solid var(--color-inactive-light);
    margin: var(--spacing-4) 0 0;
  }

  flex-direction: column;

  &-title {
    display: block;
    height: var(--spacing-4);
    text-transform: uppercase;
    font-weight: bold;
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
    margin-bottom: var(--spacing-3);

    svg {
      margin-right: var(--spacing-2);
    }
  }

  &-content {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }
}

.product-detail__block.product-detail__block--background {
  padding: 0;
  border-radius: var(--border-radius-2);
  border: none;

  > .product-detail__block-content {
    border: 1px solid var(--color-main-border);
    border-top: none;
    border-bottom-left-radius: var(--border-radius-2);
    border-bottom-right-radius: var(--border-radius-2);
    padding-bottom: var(--spacing-4);
  }

  > .product-detail__block-title {
    text-transform: none;
    border: 1px solid var(--color-main-border);
    border-bottom: none;
    border-top-left-radius: var(--border-radius-2);
    border-top-right-radius: var(--border-radius-2);
    color: var(--color-white);
    background: var(--block-title-background);
    height: auto;
    line-height: var(--line-height-xxl);
    font-size: var(--font-size-xl);
    padding: var(--spacing-2) var(--spacing-3);
    display: block;
    margin: 0;
  }
}

.no-padding {
  padding: 0;
}

.no-border {
  border-top: none;
}

.pack-product-detail__block-title {
  font-size: var(--font-size-m);
}
</style>
